import { CmsComponent } from '../../../components/cms/CmsComponent';
import { Res, useCms } from '../../../state/api';
import { UiContainer } from '../../../state/ui';
import { Loader } from '../../Loader/Loader';
import './TopHeader.css';

export const TopHeader = (): JSX.Element => {
	const { data: topheader } = useCms(Res.cmsComponent, { slug: 'top-header' });
	const ui = UiContainer.useContainer();

	return (
		<div className={`not-mobile ${ui.isHeaderSticky ? 'sticky' : ''}`}>
			{topheader ? <CmsComponent structure={topheader} /> : <Loader />}
			<hr className="hr" />
		</div>
	);
};
